import React from 'react'
import styles from './column-card.module.css'

export default ({ image, title, body }) => (
  <div className={styles.card}>
    <div className={styles.imageWrapper}>
      <img src={image} alt={title} />
    </div>
    <h4 className="h4">{title}</h4>
    <p className="body">{body}</p>
  </div>
)
